/* eslint-disable no-unused-vars */
import { TIoTDevice } from '@treedis/tour-loader';

export enum TagType {
  None = 'none',
  // Text = 'text',
  // Image = 'image',
  // Gallery = 'gallery',
  Popup = 'popup',
  Music = 'music',
  // Video = 'video',
  Iframe = 'iframe',
  Tab = 'tab',
  Panorama = 'panorama',
  Menu = 'menu',
  Matterport = 'matterport',
  MatterportInstant = 'matterport-instant',
  Treedis = 'treedis',
  VideoChat = 'video-chat',
  Navigation = 'navigation',
  ExperiencePopUp = 'experiencePopUp',
  Flow = 'flow',
}

export enum TagNavigationType {
  Menu = 'menu',
  Polygon = 'polygon',
  Tag = 'tag',
}

export enum Transition {
  Instant = 'instant',
  FlyOver = 'fly-over',
}

export enum TagRes {
  Percentage = 'percentage',
  Pixels = 'pixels',
}

export interface Tag {
  id?: number;
  title: string;
  sid: string;
  defaultSid: string;
  bookColor: string;
  bookText: string;
  bookUrl: string;
  url: string;
  urlMobile: string;
  type: TagType;
  res: TagRes;
  enabled: boolean;
  height: number;
  width: number;
  heightMobile: number;
  widthMobile: number;
  custom: boolean;
  description: string;
  iconColor: string;
  customIcon: string;
  opacity: number;
  positionX: number;
  positionY: number;
  positionZ: number;
  stemVectorX: number;
  stemVectorY: number;
  stemVectorZ: number;
  svXEnabled: boolean;
  svYEnabled: boolean;
  svZEnabled: boolean;
  text: string;
  tourId: number;
  iconFile: string;
  panoramaId: number;
  menuId: number;
  subMenuId: number;
  subSubMenuId: number;
  whiteCircle: boolean;
  transparentBackground: boolean;
  mpTitle: boolean;
  tooltip: boolean;
  mpNavigation: boolean;
  gameBackpack: boolean;
  tagGalleries: any[];
  navigationId: string;
  navigationType: TagNavigationType;
  navigationLink: string;
  fullscreen: boolean;
  autoPlay: boolean;
  embedMedia: boolean;
  dontInterruptBgAudio: boolean;
  iotDevices?: TIoTDevice[];
  treedisStyle: boolean;
  hoverTooltip: boolean;
  clickPopup: boolean;
  clickFullScreen: boolean;
  flowId: number | null;
}
